export const taskDateStartTPlanField = 'task_date_startT_plan'
export const taskDateStopTPlanField = 'task_date_stopT_plan'
export const taskDateStartTRealField = 'task_date_startT_real'
export const taskDateStopTRealField = 'task_date_stopT_real'